import { config } from './env';

export const mapsConfig = {
  apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  options: {
    libraries: ['places', 'geometry', 'marker'],
    version: 'weekly'
  },
  styles: [
    {
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [{ color: "#242f3e" }]
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{ color: "#746855" }]
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }]
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }]
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }]
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }]
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }]
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }]
    }
  ]
};

export function validateMapsConfig() {
  const apiKey = mapsConfig.apiKey;
  
  if (!apiKey || apiKey === 'undefined') {
    throw new Error('Missing or invalid Google Maps API key');
  }

  if (apiKey === 'your_google_maps_api_key_here' || apiKey === 'undefined') {
    throw new Error('Please replace the placeholder Google Maps API key with a valid key');
  }

  const isDevelopment = import.meta.env.DEV;
  const currentHost = window.location.hostname;
  const allowedDomains = [
    'localhost',
    'webcontainer.io',
    'diversicoin.cash',
    'www.diversicoin.cash',
    'stackblitz.io',
    'diversicoin.netlify.app',
    'preview.webcontainer.io'
  ];

  if (!isDevelopment && !allowedDomains.some(domain => currentHost.includes(domain))) {
    console.warn(`Warning: ${currentHost} is not in the allowed domains list`);
    // Don't throw error, just warn - the API key may still work
  }

  return true;
}